import { render } from "./oper-record-detail.vue?vue&type=template&id=248a7734&scoped=true"
import script from "./oper-record-detail.vue?vue&type=script&lang=js"
export * from "./oper-record-detail.vue?vue&type=script&lang=js"

import "./oper-record-detail.vue?vue&type=style&index=0&id=248a7734&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\YDN\\trunk\\zulin-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248a7734"]])

export default __exports__